import React, { Component } from "react";
import { connect } from "react-redux";

import { confirmAlert } from "react-confirm-alert";
import AlertContainer from "./components/alert/alertContainer.js";
import AttachmentForm from "./components/attachment/attachmentForm.js";
import ModalForm from "./components/modalForm/modalForm.js";
import ModalSpinner from "./components/spinner/modalSpinner.js";
import EmbeddedRouter from './EmbeddedRouter.js';
import ImageUpload from "./components/imageUpload/ImageUpload.jsx";
import { initializeOpenFeature } from './utils/featureFlags/openFeature';

const viewUtil = require("./utils/view/viewUtil.js");

interface Franchisor {
    code: string;
}

interface ConfirmDialogue {
    title: string;
    message: string;
    onCancel?: () => void;
    onConfirm?: () => void;
}

interface ModalFormData {
    componentCreator?: unknown;
}

interface AttachmentFormData {
    objectType?: string;
    objectId?: string;
}

interface EmbeddedViewProps {
    franchisors: Franchisor[];
    confirmDialogue: ConfirmDialogue | null;
    modalForms: ModalFormData[];
    attachmentForm: AttachmentFormData | null;
    imageUploadDialogue: unknown;
}

class EmbeddedView extends Component<EmbeddedViewProps> {

    async componentDidMount() 
    {
        const franchisors = this.props.franchisors;
        
        // Initialize OpenFeature with user context for targeting
        if (franchisors?.length > 0)
        {
            try 
            {
                const targetingKey = franchisors[0].code;
                await initializeOpenFeature({ targetingKey });
            } 
            catch (error)
            {
                console.error('Failed to initialize OpenFeature:', error);
            }
        }
    }

    render() {
        this.showConfirmationDialogue();
        return (
            <div style={{ verticalAlign: "top", padding: "0px", flex: 1, overflow: 'auto', height: '100%' }}>
                <EmbeddedRouter/>
                <AlertContainer />
                <ModalSpinner />
                {this.showImageUploadDialogue()}
                {this.showModalForm()}
                {this.showAttachmentForm()}
            </div>
        );
    }

    showConfirmationDialogue() {
        if (this.props.confirmDialogue == null) return;

        const confirmOptions = {
            title: this.props.confirmDialogue.title,
            message: this.props.confirmDialogue.message,
            buttons: [
                {
                    label: "No",
                    onClick: () => {
                        viewUtil.closeConfirmDialogue();
                        this.props.confirmDialogue?.onCancel?.();
                    },
                },
                {
                    label: "Yes",
                    onClick: () => {
                        viewUtil.closeConfirmDialogue();
                        this.props.confirmDialogue?.onConfirm?.();
                    },
                },
            ],
            afterClose: () => {
                viewUtil.closeConfirmDialogue();
            },
            overlayClassName: "confirm-alert-overlay",
        };
        confirmAlert(confirmOptions);
    }

    showImageUploadDialogue()
    {
        if (this.props.imageUploadDialogue == null)
            return;

        return <ImageUpload />
    }

    showModalForm() {
        var modalFormsComponents: JSX.Element[] = [];

        var index = 0;
        this.props.modalForms.forEach((modalForm) => {
            if (modalForm != null && modalForm.componentCreator != null) modalFormsComponents.push(<ModalForm modalFormIndex={index}></ModalForm>);

            index = index + 1;
        });

        return modalFormsComponents;
    }

    showAttachmentForm() {
        if (this.props.attachmentForm == null || this.props.attachmentForm.objectType == null || this.props.attachmentForm.objectId == null) return;

        return <AttachmentForm />;
    }
}

interface RootState {
    orgData: {
        organizationTaxonomy: {
            franchisors: Franchisor[];
        };
    };
    confirmDialogue: ConfirmDialogue | null;
    modalForms: ModalFormData[];
    attachmentForm: AttachmentFormData | null;
    imageUploadDialogue: unknown;
}

const mapStateToProps = (state: RootState) => {
    return {
        franchisors: state.orgData.organizationTaxonomy.franchisors,
        confirmDialogue: state.confirmDialogue,
        modalForms: state.modalForms,
        attachmentForm: state.attachmentForm,
        imageUploadDialogue: state.imageUploadDialogue,
    };
};

export default connect(mapStateToProps)(EmbeddedView);
